import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { ReactComponent as Home } from '../../../images/common/home.svg';

export const MainBlock = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const HomeIcon = styled(Home)`
  fill: ${ColorSF2.paleBlue};
`;
export const ScrolledBlock = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.paleBlue};
`;
export const Tbody = styled.tbody`
  background-color: ${ColorSF2.white};
`;
export const TrHead = styled.tr`
  border-top: 1px solid ${ColorSF2.white};
  text-decoration: none;
  cursor: pointer;
  height: 27px;
  font-size: 12px;
`;
export const TrBody = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: pointer;
  display: flex;
  &:last-child {
    border-bottom: 1px solid ${ColorSF2.mediumGray};
  }

  &:hover {
    background-color: ${ColorSF2.skyBlue};
    ${HomeIcon} {
      fill: ${ColorSF2.white};
    }
  }
`;
export const Th = styled.th`
  padding-left: 10px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  width: 25%;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const Td = styled.td`
  padding-left: 10px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  width: 25%;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const ThTel = styled(Th)`
  font-size: 1rem;
`;
export const TdTel = styled(Td)`
  overflow: hidden;
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 1rem;
`;
export const TdFlex = styled(TdTel)`
  display: flex;
  align-items: center;
  width: 200px;
`;
export const ChipWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const GroupInfo = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
